<script lang="ts">
    import { Button, TabContent, TabPane } from "sveltestrap";
    import { thirdsService } from "../services";
    import { Third } from "../Model/Third";
    import DirectionForm from "../components/DirectionForm.svelte";
    import AppWraper from "../components/AppWraper.svelte";
    import ParentList from "../components/ParentList.svelte";
    import { v4 as v4uuid } from 'uuid';
    import { getCurrentUser } from "../services/session";
    import { navigate } from "svelte-navigator";
    import VehicleThirdList from "../components/VehicleThirdList.svelte";
    import DiligencesListByThird from "../components/diligencesListByThird.svelte";
    import FilesList from "../components/FilesList.svelte";
    import ThirdData from "../components/thirdData.svelte";
    import KinshipList from "../components/KinshipList.svelte"
    import type { ThirdState } from "../global";
    import { error, success } from "../../public/my-theme";
    import RegisterIntoOutListByThird from "../components/RegisterIntoOutListByThird.svelte";
    import RegisterCitationListByThird from "../components/RegisterCitationListByThird.svelte";
    import RegisterDetainedListByThird from "../components/RegisterDetainedListByThird.svelte";
    import RegistersExternalAntecedentsListByThird from "../components/RegistersExternalAntecedentsListByThird.svelte";
    import ThirdLicensesList from "../components/ThirdLicensesList.svelte";

    export let thirdId: string;

    let third: ThirdState | Third;

    let thirdDataForm: ThirdData;
    let thirdAddressForm: DirectionForm;
    let thirdNotificationAddressForm: DirectionForm;
    let showDirection: boolean = false;
    let isChargeDirection: boolean = false;

    let antecedentsQuantity: number = 0;

    $: loadThird(thirdId);

    async function loadThird(thirdId: string): Promise<void> {

        if (thirdId != 'new') {
            third = await thirdsService.findOne(thirdId);
            return;
        }
       
        third = (new Third({
            id: v4uuid(),
            photo: null,
            document: '',
            surname1: '',
            surname2: '',
            genderId: null,
            name: '',
            alias: '',
            email: '',
            phone1: '',
            phone2: '',
            birthday: '',
            dateOfDeath: '',
            addressId: v4uuid(),
            addressNotificationId: v4uuid(),
            registerUserId: getCurrentUser().id,
            creationDate: '',
            updatedDate: '',
            observations: '',
            is_lawyer: false,
            has_license: false,
            collegiate_num: null
        })).getState();
    }

    async function saveThird(){
        const res = await Promise.all([
            saveDirection(),
            saveDirectionNotification(),
            thirdDataForm.saveThirdData()
        ])

        if(res.includes(undefined)){
            navigate('/tercero/' + third.id);
            success('Se han realizado los cambios correctamente.')
        } else {
            error('Error al realizar los cambios.')
            throw new Error('Error al realizar los cambios.')
        }

    }

    async function saveDirection(){
        if (!isChargeDirection) return true;
        await thirdAddressForm.saveDirection();
    }

    async function saveDirectionNotification(){
        if (!isChargeDirection) return true;
        await thirdNotificationAddressForm.saveDirection();
    }

    function accessToDirection(e){
        if (e.detail == 'dataDirection') {
            showDirection = true;
            isChargeDirection = true;
        }
    }

</script>

<style>
</style>

<AppWraper>
    {#if third}
        <div class="container-fluid p-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-9 mb-3">
                        <div class="text-start">
                            <h3>Ficha de {third.name} {third.surname1} </h3>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3 mb-3">
                        <div class="text-end">
                            <Button color="success" on:click={() => saveThird()}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </div>

                <TabContent on:tab={(e) => accessToDirection(e)}>
                    <TabPane tabId="dataThird" tab="Datos" active>
                        <div class="mt-3">
                            <ThirdData bind:this={thirdDataForm} bind:thirdData={third} />
                        </div>
                    </TabPane>
                    <TabPane tabId="dataDirection" tab="Direcciones">
                        {#if showDirection}
                            <div class="row mt-3">
                                <div class="col-12 col-sm-9 mb-3">
                                    <div class="text-start">
                                        <h5>Dirección Principal</h5>
                                    </div>
                                </div>
                            </div>
                            <DirectionForm bind:this={thirdAddressForm} thirdId={third.id} directionId = {third.addressId}/>
                            <div class="row">
                                <hr>
                                <div class="col-12 col-sm-9 mb-3">
                                    <div class="text-start">
                                        <h5>Dirección de Notificación</h5>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3 mb-3">
                                    <div class="text-end">
                                        <Button color="primary" on:click={() => thirdNotificationAddressForm.cloneDirection(third.addressId)}>
                                            Copiar Dirección
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <DirectionForm bind:this={thirdNotificationAddressForm} thirdId={third.id}  directionId = {third.addressNotificationId}/>
                        {/if}
                    </TabPane>
                    <TabPane tabId="vehiclesThird" tab="Vehículos">
                        <VehicleThirdList thirId={third.id}/>
                    </TabPane>
                    <TabPane tabId="parentThird" tab="Relaciones">
                        <KinshipList thirdId={third.id}/>
                    </TabPane>
                    <TabPane tabId="thirdRecord" tab="Historial">
                        <h4 class='mt-4'>Diligencias</h4>
                        <DiligencesListByThird thirdId={third.id}/>
                        <h4 class='mt-5'>Registro de entrada/salida</h4>
                        <RegisterIntoOutListByThird  third_id={third.id}/> 
                        <h4 class='mt-5'>Registro de citaciones</h4>
                        <RegisterCitationListByThird third_id={third.id} />
                        <h4 class='mt-5'>Registro de detenciones</h4>
                        <RegisterDetainedListByThird third_id={third.id} />
                    </TabPane>
                    <TabPane tabId="antecedents" tab="Antecedentes ({antecedentsQuantity})">
                        <RegistersExternalAntecedentsListByThird bind:quantity={antecedentsQuantity} third_id={third.id} />
                    </TabPane>
                    <TabPane tabId="FilesList" tab="Archivos">
                        <div class="mt-3">
                            <FilesList contextId={third.id}/>
                        </div>
                    </TabPane>
                    <TabPane tabId="LicenseList" tab="Permisos de conducir">
                        <div class="mt-3">
                            <ThirdLicensesList thirdId={third.id} />
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    {/if}



</AppWraper>



